import GlassWidgetPanel from './GlassWidgetPanel';

export default GlassWidgetPanel;
